import React from 'react';
import store from 'store';
import PropTypes from 'prop-types';
import { config } from '../../utils/config';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ redirectPath = config.path.index, children }) => {
    const user = store.get(config.storage.token);

    if (user) {
        return <Navigate to={redirectPath} replace />;
    }

    return children;
};

PublicRoute.propTypes = {
    redirectPath: PropTypes.string,
    children: PropTypes.element.isRequired
};

export default PublicRoute;
